export const Window = typeof window !== 'undefined' && window

export const getItemIndexByProperty = (array, property, value) =>
  array.map(e => e[property]).indexOf(value)

export const checkPathnameMatchWithWildcard = (currentPath, toMatch) =>
  toMatch.includes('*')
    ? currentPath.startsWith(`/${toMatch.replace('*', '')}`)
    : currentPath === `/${toMatch}`

export const insert = (arr, item, index) =>
  arr.reduce(function(s, a, i) {
    i === index ? s.push(item, a) : s.push(a)
    return s
  }, [])

export function sum(obj) {
  var sum = 0
  for (var el in obj) {
    if (obj.hasOwnProperty(el)) {
      sum += parseFloat(obj[el])
    }
  }
  return sum
}
